import { createServerFn } from "@tanstack/react-start";

import type { CollectionItem } from "@/lib/collection";
import { toCollectionItem } from "@/lib/studio";

/** Public collection pieces — server-only so supabase-js stays out of the first-load bundle. */
export const fetchPublishedStudioPieces = createServerFn({ method: "GET" }).handler(
  async (): Promise<CollectionItem[]> => {
    try {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data, error } = await supabase
        .from("collection_pieces")
        .select("*")
        .eq("published", true)
        .order("sort_order", { ascending: true })
        .order("created_at", { ascending: false });
      if (error || !data) {
        if (error) console.error("studio pieces", error.message);
        return [];
      }
      return data.map(toCollectionItem);
    } catch (error) {
      console.error("studio pieces", error);
      return [];
    }
  },
);
